"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "login": {
    "onlineTraining": "Nền tảng đào tạo trực tuyến của Học viện điện tử Liaogao",
    "captchaNotEmpty": "mã xác minh phải được điền",
    "accountNotEmpty": "Tài khoản không được để trống",
    "passwordBits": "Độ dài mật khẩu không được dưới 6 chữ số",
    "incorrectTips": "Tên người dùng hoặc mật khẩu nhập sai",
    "sign": "đăng nhập",
    "passwordNotEmpty": "mật khẩu không được để trống",
    "passwordBitsLong": "Độ dài mật khẩu không được lớn hơn 18 chữ số",
    "captchaTips": "Mã xác minh không chính xác",
    "confirmNot": "Mật khẩu đã nhập không phù hợp với mật khẩu đã xác nhận",
    "inputAccount": "Vui lòng nhập Tên người dùng",
    "inputPassword": "Xin vui lòng nhập mật khẩu",
    "inputCaptcha": "vui lòng nhập mã xác nhận",
    "forgetPassword": "quên mật khẩu",
    "nextStep": "Bước tiếp theo",
    "inputUserName": "Vui lòng nhập tên người dùng",
    "phoneNumber": "số điện thoại",
    "phoneEmpty": "Số điện thoại không được để trống",
    "surePasswordEmpty": "xác nhận mật khẩu không được để trống",
    "userNameEmpty": "Tên ngươi dung không được để trông",
    "getCaptcha": "lấy mã xác minh",
    "msgCaptcha": "Mã xác minh SMS",
    "prevStep": "Trước",
    "surePassword": "Vui lòng xác nhận mật khẩu của bạn",
    "reset": "Cài lại",
    "resetSuccess": "Đặt lại thành công",
    "resetSuccessTips": "Bạn đã đặt lại mật khẩu thành công, vui lòng đăng nhập",
    "loginNow": "Đăng nhập ngay",
    "copyRight": "Bản quyền thuộc sở hữu của ×××××××××, Copyright @ 2020 京 ICP 备案",
    "loginFail": "Đăng nhập thất bại. Xin hãy thử lại!",
    "captchaFail": "Xác minh mã xác minh không thành công",
    "failTips": "Xác minh không hoàn thành",
    "inputOrigPassword": "Vui lòng nhập mật khẩu ban đầu",
    "inputNewPassowrd": "Vui lòng nhập mật khẩu mới",
    "confimPassword": "Vui lòng xác nhận mật khẩu của bạn",
    "sure": "mục đích",
    "cancel": "hủy bỏ",
    "changePasswordSuccess": "mật khẩu đã được cập nhật",
    "continueLogin": "đăng ký lại",
    "resetLoginTips": "Bạn đã đổi mật khẩu thành công, bạn cần đăng nhập lại và tự động đăng xuất sau 3 giây",
    "passwordFormat": "Độ dài mật khẩu là 8 đến 32 chữ số, bao gồm cả số và chữ hoa và chữ thường",
    "changePassword": "đổi mật khẩu",
    "poor": "Yếu",
    "middle": "trong",
    "strong": "Mạnh",
    "logout": "Đăng xuất thành công",
    "formerPhone": "Số điện thoại ban đầu",
    "newPhone": "Số điện thoại mới",
    "changePhoneSuccess": "Đã sửa đổi số điện thoại di động thành công",
    "changePhoneSuccessTips": "Bạn đã sửa đổi thành công số điện thoại của mình",
    "goHome": "Về nhà",
    "changePhone": "Sửa đổi số điện thoại di động",
    "newPhoneEmpty": "Số điện thoại mới không được để trống",
    "newPhoneFomat": "Định dạng số điện thoại mới không chính xác",
    "newPhoneSupport": "Số điện thoại mới không được giống với số điện thoại ban đầu",
    "newPhoneBinded": "Số điện thoại mới đã bị ràng buộc",
    "orgPhoneEmpty": "Số điện thoại ban đầu không được để trống",
    "orgPhoneFormat": "Định dạng số điện thoại ban đầu không chính xác",
    "orgPhoneNot": "Số điện thoại ban đầu không chính xác",
    "resetPassword": "đặt lại mật khẩu",
    "phoneCaptchaEmpty": "Mã xác minh điện thoại không được để trống",
    "accountVerif": "Xác minh tài khoản",
    "phoneVerif": "Xác minh điện thoại",
    "resetDone": "Đặt lại hoàn tất",
    "phoneFormat": "Định dạng số điện thoại không đúng",
    "phoneBinded": "Số điện thoại di động đã bị ràng buộc",
    "loginVertif": "Xác thực đăng nhập",
    "clickGoHome": "Bấm để quay lại trang đăng nhập",
    "bingPhoneSuccess": "Liên kết số điện thoại di động thành công",
    "rightMessageChange": "Bạn có thể chỉnh sửa nó trong thông tin cá nhân ở phía bên phải của thanh điều hướng",
    "bingPhone": "Ràng buộc số điện thoại di động"
  },
  "index": {
    "setAsHomePage": "Thiết lập làm trang đầu",
    "addCollection": "Thêm vào mục yêu thích",
    "telephone": "đường dây nóng hỗ trợ",
    "Help": "Trung tâm trợ giúp",
    "SystemMessage": "Hệ thống nhắc nhở",
    "message": "Tin tức",
    "emptyMessage": "Trống",
    "checkAllMessage": "xem tất cả",
    "noMessage": "Không có dữ liệu",
    "fullScreen": "Hiển thị toàn màn hình",
    "ExitSystem": "Thoát khỏi hệ thống này",
    "back": "trở về",
    "top": "hàng đầu",
    "backToTop": "Trở lại đầu trang",
    "homePage": "Trang Chủ",
    "course": "Khóa học học tập",
    "onlineCourse": "Lớp học đặc biệt trực tuyến",
    "faceCourse": "Đào tạo trực diện",
    "examPractice": "Luyện thi",
    "dataDownLoad": "Tải xuống",
    "userInfo": "Trung tâm cá nhân",
    "Administration": "Nền tảng quản lý",
    "courseCategory": "các loại khóa học",
    "examIsOver": "Đánh giá đã hoàn thành",
    "onlineHours": "Giờ trực tuyến",
    "faceHours": "Giờ học trực tiếp",
    "notice": "sự thông báo",
    "checkAllNotice": "xem tất cả",
    "backToTopButton": "Trở lại đầu trang",
    "recommendCourse": "Các khóa học được đề xuất",
    "impotentCourse": "Khóa học chính",
    "newCourse": "Các khóa học mới nhất",
    "hotCourse": "Khóa học hấp dẫn nhất",
    "requiredCourses": "Khóa học bắt buộc",
    "electiveCourses": "Khóa học tự chọn",
    "startStudy": "bắt đầu học",
    "continueStudy": "Tiếp tục học",
    "coursesRanking": "Xếp hạng lựa chọn khóa học",
    "studentRanking": "Xếp hạng sinh viên",
    "currentUser": "Người dùng hiện tại",
    "userHead": "ảnh đại diện",
    "currentHead": "Hình đại diện hiện tại",
    "change": "sửa đổi",
    "accountPassword": "mật khẩu tài khoản",
    "encryPhone": "Điện thoại bí mật",
    "currentPhone": "Điện thoại hiện tại",
    "userName": "tên tài khoản",
    "head": "hình đại diện",
    "coverImage": "ảnh bìa",
    "uploadError": "tải lên không thành công",
    "autoSetHomeTips": "Trình duyệt của bạn không hỗ trợ cài đặt trang chủ tự động, vui lòng sử dụng menu của trình duyệt để thiết lập thủ công!",
    "operateConfig": "Thao tác này bị trình duyệt từ chối. Nếu bạn muốn bật chức năng này, vui lòng nhập about: config vào thanh địa chỉ, sau đó đặt giá trị của sign.applets.codebase_principal_support thành true",
    "favoriteTips": "Do giới hạn của chức năng trình duyệt 360, vui lòng nhấn Ctrl + D để đánh dấu theo cách thủ công!",
    "autoFavorite": "Trình duyệt của bạn không hỗ trợ, vui lòng nhấn Ctrl + D để đánh dấu theo cách thủ công!",
    "required": "Mục này là bắt buộc",
    "to": "đến",
    "trainingTime": "thời gian luyện tập",
    "coursehours": "Giờ học",
    "human": "Mọi người",
    "wecome": "Chào mừng!",
    "allCourses": "Tất cả các khóa học"
  },
  "course": {
    "coursesCategory": "các loại khóa học",
    "allCourses": "Tất cả các khóa học",
    "electiveCourses": "Khóa học tự chọn",
    "requiredCourses": "Khóa học yêu cầu",
    "collect": "Yêu thích",
    "cancelCollect": "Bỏ yêu thích",
    "searchTips": "Vui lòng nhập tên khóa học",
    "startStudy": "bắt đầu học",
    "continueStudy": "Tiếp tục học",
    "cancelConfirm": "Bỏ yêu thích",
    "cancelTips": "Xác nhận để hủy lời nhắc",
    "confirmButton": "Nút hủy",
    "count": "Toàn bộ",
    "item": "Bài báo",
    "up": "Trang trước",
    "next": "Trang tiếp theo",
    "items": "Bài viết / Trang",
    "go": "Chuyển đến",
    "page": "trang",
    "man": "Mọi người",
    "score": "Phút",
    "courseYear": "năm",
    "courseTeachers": "giáo viên",
    "noDesc": "Không giới thiệu",
    "teachersDesc": "Hồ sơ giáo viên",
    "checkLog": "Xem hồ sơ",
    "reExam": "Thi lại",
    "examLog": "Hồ sơ kỳ thi",
    "viewPaper": "Xem giấy kiểm tra",
    "noPublicExam": "Bài thi sẽ không được công bố",
    "marking": "Đánh dấu",
    "closeButton": "tắt",
    "examResultPage": "Trang kết quả thi",
    "examPage": "Trang thi",
    "startExam": "Bắt đầu kỳ thi",
    "coursehours": "Giờ học",
    "courseInfo": "Chi tiết khóa học",
    "courseChapter": "Các chương khóa học",
    "courseNote": "Ghi chú khóa học",
    "courseData": "Thông tin khóa học",
    "courseExamination": "Thi",
    "evaluate": "Đánh giá",
    "courseEvaluate": "Đánh giá khoa học",
    "no": "Đầu tiên",
    "chapter": "chương",
    "isEvaluate": "Đã đánh giá",
    "uploadDate": "Thời gian tải lên",
    "className": "Tên lớp",
    "resourceSize": "Quy mô tài nguyên",
    "times": "Times",
    "typeViedo": "video",
    "typeImage": "hình ảnh",
    "typeDoc": "Tài liệu",
    "typeOuth": "khác",
    "typeImages": "Nhiều hình ảnh",
    "newComment": "cập nhật",
    "hotComment": "Nóng nhất",
    "openComment": "Tôi muốn bình luận",
    "cancelButton": "hủy bỏ",
    "publishButton": "giải phóng",
    "commentTips": "Vui lòng nhập nội dung bình luận",
    "emptyCommentTips": "Nội dung nhận xét không được để trống",
    "noteSource": "Từ",
    "deleteNoteButton": "xóa bỏ",
    "needIETips": "Phần mềm học liệu hiện tại yêu cầu trình duyệt IE!",
    "donwNum": "thời gian tải xuống",
    "preview": "Xem trước",
    "relatedCourses": "Các khóa học liên quan",
    "studentsNum": "Số lượng khóa học",
    "courseHours": "Giờ học",
    "JoinLearning": "Tham gia học tập"
  },
  "onlineclass": {
    "allTheClass": "Tất cả các lớp học",
    "beginClass": "Lớp học bắt đầu",
    "notBeginClass": "Không có lớp học",
    "endClass": "Đóng cửa",
    "searchThoseClass": "Tìm kiếm lớp học đặc biệt trực tuyến mà bạn quan tâm",
    "startLearn": "Vào lớp",
    "registrationTime": "thời gian đăng ký",
    "to": "đến",
    "trainingTime": "thời gian luyện tập",
    "subjectsClass": "Các khóa học",
    "classStudy": "Học trên lớp",
    "quantityOfCourses": "Số lượng khóa học",
    "numberOfParticipants": "Số người nộp đơn",
    "registerNow": "đăng ký ngay",
    "resetRegister": "Rút tên",
    "participating": "Đã tham gia",
    "subjects": "cửa",
    "classExam": "Kỳ thi trên lớp",
    "notParticipat": "Không liên quan",
    "startExim": "Bắt đầu kỳ thi",
    "handed": "thực hiện một nhiệm vụ",
    "score": "Ghi bàn",
    "cacheSave": "Lưu trữ tạm thời",
    "subjectsNumber": "Số lượng cửa",
    "notice": "Để ý",
    "communication": "giao tiếp",
    "detail": "Chi tiết",
    "courses": "khóa học",
    "allClass": "Tất cả",
    "compulsory": "Bắt buộc",
    "elective": "Tự chọn",
    "Learned": "Đã học",
    "classPassIndicator": "Chỉ số vượt qua lớp",
    "excellence": "thông minh",
    "compulsoryNumber": "Số lần vượt qua yêu cầu",
    "electiveNumber": "Số khóa học tự chọn đã thông qua",
    "compulsoryStandard": "Giờ tiêu chuẩn bắt buộc",
    "electiveStandard": "Giờ tự chọn",
    "examIsPass": "Kỳ thi có vượt qua không",
    "resource": "Tài nguyên",
    "source": "dữ liệu",
    "new": "cập nhật",
    "hot": "Nóng nhất",
    "updateTime": "Thời gian tải lên",
    "downloadCount": "Tải xuống",
    "download": "Tải xuống",
    "resourceSize": "Quy mô tài nguyên",
    "resourceType": "Các loại",
    "allType": "Các loại",
    "videos": "video",
    "images": "hình ảnh",
    "document": "Tài liệu",
    "others": "khác",
    "multiImages": "Nhiều hình ảnh",
    "inforCertificate": "chứng chỉ",
    "notSubmit": "không gửi",
    "submitHomework": "nộp bài tập về nhà",
    "submitTime": "Thời gian gửi",
    "uploadHomework": "Tải lên bài tập",
    "clickHere": "bấm vào đây",
    "upload": "Tải lên",
    "formatSupport": "Hỗ trợ định dạng tệp",
    "submited": "nộp",
    "notApproved": "Chưa được đánh giá",
    "approved": "kỳ thi đã qua",
    "downloadHomework": "Tải xuống bài tập",
    "reSubmit": "Gửi lại",
    "myScore": "Điểm số của tôi",
    "comments": "Bình luận",
    "talk": "bàn luận",
    "category": "phân loại",
    "classTalk": "Thảo luận trong lớp",
    "groupTalk": "thảo luận nhóm",
    "wantTalk": "Tôi muốn thảo luận",
    "publish": "giải phóng",
    "undo": "hủy bỏ",
    "delete": "xóa bỏ",
    "iknow": "Tôi hiểu rồi",
    "faceCourseClass": "Đào tạo trực diện",
    "onlineClasses": "Lớp học đặc biệt trực tuyến",
    "openReservation": "Mở để đăng ký",
    "talkTech": "giảng viên",
    "address": "vị trí",
    "up": "trên",
    "noon": "Không bật",
    "down": "Dưới",
    "even": "muộn",
    "classOvered": "Lớp học đã đóng cửa",
    "nopassed": "Vẫn chưa được đăng ký",
    "inputTalkContent": "Vui lòng nhập nội dung thảo luận",
    "groupMan": "Trưởng nhóm",
    "showAllGroup": "Xem tất cả các thành viên",
    "hideAllGroup": "Bỏ tất cả các thành viên trong nhóm",
    "showAllMan": "Xem tất cả học sinh",
    "hideAllMan": "Bỏ tất cả học sinh",
    "reply": "Đáp lại",
    "isDelete": "Bạn có chắc chắn muốn xóa không?",
    "cancelLike": "không giống",
    "classNotStar": "Đăng ký lớp học chưa bắt đầu",
    "classIsEnd": "Đăng ký lớp học đã kết thúc",
    "clickReset": "Nhấp vào nút để xóa tên",
    "agentRegister": "Đăng ký lại",
    "cancelRegister": "Hủy đăng ký",
    "reason": "nguyên nhân",
    "inputReason": "Vui lòng nhập lý do thu hồi",
    "homework": "hoạt động",
    "leaveMaxBits": "Lý do xin nghỉ không được quá 100 từ",
    "leaveNotEndTime": "Thời gian bắt đầu nghỉ phép không được bằng thời gian kết thúc",
    "sizeNot": "Kích thước không được vượt quá",
    "close": "tắt",
    "teacher": "giáo viên",
    "noIntroduction": "Không giới thiệu"
  },
  "offlineclass": {
    "fullTimeToFace": "Hướng dẫn trực tiếp toàn thời gian",
    "onlineToFace": "Trong công việc",
    "allClass": "Tất cả các lớp học",
    "openClass": "Mở lớp",
    "searchThoseClass": "Tìm kiếm các khóa đào tạo trực tiếp mà bạn quan tâm",
    "startLearn": "Nhập học",
    "classHours": "Giờ học",
    "h": "Thời gian",
    "firstWeek": "Tuần 1",
    "askLeave": "Tôi muốn nghỉ phép",
    "monday": "Thứ hai",
    "tuesday": "Thứ ba",
    "wednesday": "Thứ tư",
    "thursday": "Thứ năm",
    "fridays": "Thứ sáu",
    "saturdays": "vào thứ bảy",
    "sunday": "vào ngày Chủ nhật",
    "morning": "buổi sáng",
    "afternoon": "vào buổi chiều",
    "evening": "vào ban đêm",
    "leaveType": "Loại nghỉ phép",
    "selectLeaveType": "Vui lòng chọn loại rời",
    "leaveTime": "Thời gian nghỉ",
    "selctLeaveTime": "Vui lòng chọn thời gian nghỉ",
    "reasonLeave": "Lý do nghỉ việc",
    "inputReasonLeave": "Vui lòng nhập lý do nghỉ việc",
    "sure": "mục đích",
    "selectTime": "thời gian lựa chọn",
    "casualLeave": "Nghỉ phép cá nhân",
    "sickLeave": "nghỉ ốm",
    "seven": "ngày",
    "one": "Một",
    "two": "hai",
    "three": "số ba",
    "for": "bốn",
    "five": "Fives",
    "six": "sáu",
    "clear": "Trống",
    "evaluating": "Đánh giá",
    "courseEvaluation": "Đánh giá giảng dạy",
    "inputEvaluating": "Vui lòng nhập nội dung đánh giá",
    "beDoing": "Trong tiến trình",
    "notStarted": "chưa bắt đầu",
    "evaluationInProgress": "Đang đánh giá",
    "notEvaluation": "Không được đánh giá",
    "evaluationStartTime": "Thời gian bắt đầu đánh giá",
    "startEvaluation": "Bắt đầu đánh giá",
    "classEvaluation": "Đánh giá lớp học",
    "photoCategory": "Phân loại album",
    "learningActivity": "Hoạt động học tập",
    "addPhoto": "Ảnh mới được thêm vào",
    "photoMessage": "Thông tin ảnh",
    "photoName": "Tên ảnh",
    "inputPhotoName": "Vui lòng nhập tên ảnh",
    "uploadPhoto": "Tải ảnh lên",
    "formatSupport": "Hỗ trợ định dạng hỗ trợ",
    "tickets": "Zhang",
    "group": "nhóm",
    "notGroup": "chưa được phân loại",
    "groupTalk": "Thảo luận nhóm",
    "teacherAbout": "Hồ sơ giáo viên",
    "teacherTech": "Các khóa học đã nhận",
    "photos": "album ảnh",
    "phontoRequier": "Ảnh phải được tải lên",
    "addPhoneTips": "Đã thêm thành công, vui lòng chờ xem xét",
    "sureDelete": "Bạn có chắc chắn muốn xóa",
    "deleteSuccess": "đã xóa thành công",
    "phoneNameReq": "Trường tên ảnh là bắt buộc",
    "longNotBits": "Độ dài không được vượt quá 50 ký tự",
    "phoneIsOccur": "Tên ảnh đã tồn tại",
    "evaluateTime": "Thời gian đánh giá",
    "evalueteNotStar": "Đánh giá chưa bắt đầu",
    "evaluateEnds": "Đánh giá đã kết thúc",
    "isEvaluated": "Đánh giá",
    "at": "trong",
    "submit": "Gửi đi",
    "seeEvalute": "Xem đánh giá",
    "inputIdea": "Vui lòng nhập suy nghĩ của bạn",
    "submitFailure": "Không nộp được",
    "seeRecord": "Xem hồ sơ",
    "examRecord": "Hồ sơ kỳ thi",
    "seeSubmite": "Xem giấy kiểm tra",
    "resultPage": "Trang kết quả thi",
    "hoursStandard": "Không thể thi nếu giờ học không đạt tiêu chuẩn",
    "examPage": "Trang thi",
    "questionnaire": "Bảng câu hỏi",
    " coursesTaught": "Khóa học dạy",
    "passed": "bởi",
    "is": "Đúng",
    "not": "Không",
    "passedState": "Vượt qua trạng thái",
    "sketch": "bản nháp",
    "partySchool": "Lớp bồi dưỡng Trường Đảng",
    "searchPartySchool": "Tìm kiếm lớp đào tạo trường đảng mà bạn quan tâm"
  },
  "exam": {
    "answerWarning": "Câu hỏi của kỳ thi này là một câu hỏi duy nhất không thể thay đổi, hãy cẩn thận trước câu hỏi tiếp theo",
    "inputAnswerTips": "Xin hãy nhập câu trả lời của bạn",
    "problemPoints": "Phân tích vấn đề",
    "examination": "Đăng ký một kỳ thi",
    "knowledgeCompetition": "Cuộc thi kiến ​​thức",
    "practice": "Thực hành tự chủ",
    "notRegister": "Chưa đăng ký",
    "reviewAudit": "đang xem xét",
    "auditNoPass": "Kiểm tra không thành công",
    "participanted": "đã đăng ký",
    "participant": "Đăng ký",
    "examTime": "thời gian kiểm tra",
    "examHours": "thời hạn",
    "registration": "Đăng ký thành công",
    "reRegistration": "Rút tên",
    "wrongQuestion": "Ngân hàng câu hỏi sai",
    "noInvolvement": "Không liên quan",
    "involvement": "Đã tham gia",
    "searchExamPractice": "Tìm kiếm các bài kiểm tra và bài tập mà bạn quan tâm",
    "practiced": "Thực hành",
    "startPractice": "Bắt đầu luyện tập",
    "toFavorite": "Thêm vào mục yêu thích",
    "prevPrevious": "Câu hỏi trước",
    "nextPrevious": "câu hỏi tiếp theo",
    "submitAnswers": "Cung cấp câu trả lời",
    "rightAnswers": "Câu trả lời chính xác",
    "yourAnswers": "câu trả lời của bạn",
    "questionsAnalysis": "Phân tích câu hỏi",
    "noAnalysis": "Không có độ phân giải",
    "accuracy": "Tỷ lệ chính xác",
    "continuePracticed": "Tiếp tục tập luyện",
    "topics": "đề tài"
  },
  "source": {
    "allResource": "Tất cả tài nguyên",
    "commonResource": "Nguồn lực chung",
    "classResource": "Tài nguyên lớp",
    "resourceCategory": "Phân loại tài nguyên",
    "searchResource": "Tìm kiếm tài nguyên bạn quan tâm",
    "resourceTalk": "Đánh giá tài nguyên",
    "previewResource": "Xem trước tài nguyên",
    "helpPoint": "Hướng dẫn trợ giúp",
    "isEvaluation": "Bạn đã đánh giá rồi!",
    "selectEvaluation": "Bạn chưa chọn xếp hạng!",
    "evaluationSuccess": "Đánh giá thành công",
    "topRelise": "Hàng đầu",
    "className": "Tên lớp",
    "resourceEvaluation": "Đánh giá tài nguyên"
  },
  "usercenter": {
    "386": "Hồ sơ học tập",
    "myCourse": "Các khóa học của tôi",
    "hours": "Thời gian",
    "loginAccount": "Đăng nhập tài khoản",
    "htllo": "xin chào",
    "welcomeMessage": "Chúc bạn vui vẻ mỗi ngày",
    "underway": "Bạn đang làm",
    "annualAssessment": "Đánh giá hàng năm",
    "searchTips": "Nhập tên khóa học đã tìm kiếm",
    "completed": "Đã kết thúc",
    "allCourses": "Tất cả các khóa học",
    "requiredCourses": "Khóa học yêu cầu",
    "electiveCourses": "Khóa học tự chọn",
    "all": "Tất cả",
    "ongoing": "Chế biến",
    "learnTo": "Học",
    "inExams": "Làm bài kiểm tra",
    "noExams": "Không có kỳ thi",
    "delete": "xóa bỏ",
    "pleaseSelect": "xin vui lòng chọn",
    "searchOnlineTips": "Tìm kiếm các lớp học đặc biệt trực tuyến mà bạn quan tâm",
    "passedCourse": "thông qua",
    "failedCourse": "Không vượt qua",
    "myOnlineCourse": "Lớp học đặc biệt trực tuyến của tôi",
    "myFaceCourse": "Lớp đào tạo mặt đối mặt của tôi",
    "searchFaceTips": "Tìm kiếm các khóa học bạn quan tâm",
    "myExams": "Bài thi của tôi",
    "allExams": "Tất cả các kỳ thi",
    "makeUpExam": "Được tạo nên",
    "marking": "Đánh dấu",
    "onExam": "Đang trong kỳ thi",
    "passedExam": "Đã vượt qua kỳ thi",
    "examHours": "Thời lượng kiểm tra",
    "examOver": "Kỳ thi kết thúc",
    "exam": "kiểm tra",
    "examLog": "Hồ sơ kỳ thi",
    "myScore": "Điểm số của tôi",
    "surplusMakeUpExam": "Bài kiểm tra trang điểm còn lại",
    "times": "Times",
    "searchExamTips": "Nhập tên tìm kiếm",
    "haveTime": "Thời gian còn lại",
    "question": "câu hỏi",
    "eachQuestion": "Mỗi câu hỏi",
    "score": "Phút",
    "examExplain": "Mô tả bài kiểm tra",
    "confirmHandExams": "Có xác nhận việc gửi hay không",
    "autoSaveFailed": "Tự động lưu không thành công",
    "autoSaveSuccess": "Tự động lưu",
    "handExamsSuccess": "Đã giao nộp thành công",
    "yourScore": "Số điểm của bạn",
    "noPublicAnswers": "Câu trả lời sẽ không được công bố cho kỳ thi này",
    "noPublicResult": "Bài thi sẽ không được công bố",
    "reExam": "Kiểm tra lại",
    "practice": "Tập thể dục",
    "hasCollected": "thu thập",
    "emptyAnswer": "Nội dung tùy chọn hoặc câu trả lời không được để trống",
    "isCorrect": "Giải pháp tích cực",
    "myCollected": "bộ sưu tập của tôi",
    "courseCollected": "Bộ sưu tập khóa học",
    "examCollected": "Câu hỏi kiểm tra",
    "deleteCollected": "Xóa mục ưa thích",
    "myLeave": "Nghỉ phép của tôi",
    "allLeave": "Tất cả rời đi",
    "needAudit": "Đang chờ xử lý",
    "auditDate": "thời gian nộp đơn",
    "searchLeaveTips": "Tìm kiếm nghỉ phép mà bạn quan tâm",
    "checkInfo": "xem chi tiết",
    "cancelLeave": "Thu hồi giấy nghỉ phép",
    "leaveInfo": "Để lại thông tin chi tiết",
    "leaveState": "Tình trạng hiện tại",
    "teamLeader": "Trưởng nhóm",
    "committeeMembers": "Ban kiểm tra kỷ luật tổ chức",
    "headmaster": "hiệu trưởng",
    "schoolLeader": "Lãnh đạo trường",
    "student": "Thực tập sinh",
    "auditMessage": "Lý do phê duyệt",
    "onBusiness": "Cho doanh nghiệp",
    "personal": "Vì lý do cá nhân",
    "rejectReasons": "Lý do từ chối",
    "confirmCancel": "Xác nhận xem có hủy bỏ đơn nghỉ không",
    "cancelButton": "Thu hồi",
    "cancelTitle": "Xác nhận thu hồi",
    "empty": "Không",
    "wrongQuestionBank": "Ngân hàng câu hỏi sai của tôi",
    "searchWrongTips": "Tìm kiếm câu hỏi sai mà bạn quan tâm",
    "deleteWrongQuestion": "Xóa ngân hàng câu hỏi sai",
    "myQuestionnaire": "Bảng câu hỏi của tôi",
    "isCompleted": "hoàn thành",
    "isOver": "kết thúc",
    "searchQuestionnaireTips": "Nhập tên bảng câu hỏi tìm kiếm",
    "questionnaireDate": "Thời gian bảng câu hỏi",
    "startQuestionnaire": "Bắt đầu trả lời",
    "checkQuestionnaire": "Xem bảng câu hỏi",
    "allTeacher": "Tất cả giáo viên",
    "newTeacher": "Thêm giáo viên",
    "searchTeacherTips": "Tìm kiếm giáo viên mà bạn quan tâm",
    "checkTeacher": "Lượt xem",
    "editTeacher": "biên tập",
    "workingIn": "Đã làm việc tại",
    "location": "Vị trí cố định",
    "confirmDelete": "Xóa xác nhận",
    "confirmDeleteTips": "Xác nhận xóa",
    "recommendTeacher": "Lời giới thiệu của giáo viên",
    "addTeachers": "Giáo viên mới",
    "teacherInfo": "Thông tin cá nhân",
    "teacherName": "Tên giáo viên",
    "workUnit": "Chủ nhân",
    "contact": "chi tiết liên hệ",
    "teacherNameTips": "Vui lòng nhập tên của giáo viên",
    "teacherWorkUnitTips": "Vui lòng nhập nhà tuyển dụng",
    "teacherContactTips": "Vui lòng nhập thông tin liên hệ của giáo viên",
    "teacherLocationTips": "Vui lòng nhập vị trí thường trú",
    "teacherDescTips": "Vui lòng nhập hồ sơ giáo viên",
    "teachingInfo": "Thông tin giảng dạy",
    "teachingExpertise": "Giảng dạy chuyên môn",
    "fitLevel": "Phù hợp với cấp độ đối tượng giảng dạy",
    "fitBusiness": "Phù hợp với ngành nghề kinh doanh",
    "ruleNumber": "Vui lòng nhập một số nguyên có 8 chữ số (bao gồm 8)",
    "rulePhone": "Xin vui lòng nhập một số điện thoại hợp lệ",
    "ruleString": "Vui lòng nhập 80 ký tự (bao gồm 80)",
    "ruleIsNumber": "Vui lòng nhập số",
    "pause": "Lưu trữ tạm thời",
    "teachingStyle": "Phong cách bài giảng",
    "teachingExpertiseTips": "Vui lòng nhập kiến ​​thức chuyên môn giảng dạy của giáo viên",
    "fitLevelTips": "Vui lòng chọn cấp độ phù hợp với đối tượng mục tiêu",
    "fitBusinessTips": "Hãy chọn ngành nghề kinh doanh phù hợp",
    "chargeInfoTips": "Vui lòng nhập tiêu chuẩn sạc",
    "teachingStyleTips": "Vui lòng nhập kiểu bài giảng của giáo viên",
    "otherInfo": "Thông tin khác",
    "recommendUnit": "Đề nghị từ",
    "otherOption": "Cac vân đê khac",
    "otherOptionTips": "Vui lòng nhập những thứ khác cần bổ sung",
    "isRequired": "Mục này là bắt buộc",
    "pauseSuccess": "Lưu thành công",
    "phoneWrong": "Xin vui lòng nhập một số điện thoại hợp lệ",
    "junior": "Học sinh trung học cơ sở",
    "highSchool": "Học sinh trung học",
    "english": "Tiếng Anh",
    "mathematics": "toán học",
    "recommendSuccessTips": "Bạn đã gửi thành công giáo viên được đề xuất. Sau khi đánh giá được thông qua, giáo viên sẽ được thêm vào nhóm giáo viên",
    "goBackrecommend": "Quay lại đề xuất của giáo viên",
    "checkTeacherInfo": "Xem giáo viên",
    "currentState": "Tình trạng hiện tại",
    "chargeInfo": "Các khoản phí",
    "myCertificate": "Chứng chỉ của tôi",
    "learningArchives": "Hồ sơ học tập",
    "allCertificate": "Tất cả các chứng chỉ",
    "onlineCourse": "Lớp học trực tuyến",
    "faceCourse": "Lớp học trực diện",
    "exams": "kiểm tra",
    "baseInfo": "thông tin cơ bản",
    "userName": "tên tài khoản",
    "name": "Tên",
    "company": "Đơn vị hiện tại",
    "learningExperience": "Học lịch sử",
    "assessmentIndex": "Chỉ số đánh giá",
    "assessmentStatus": "Tình trạng đánh giá",
    "assessmentTime": "thời gian kiểm tra",
    "onlineLearning": "Học trực tuyến",
    "year": "năm",
    "faceOutProduceHours": "Hướng dẫn trực tiếp (giờ học)",
    "notFaceOutProduceHours": "Hướng dẫn trực tiếp không toàn thời gian (giờ học)",
    "onlineCenterLearnHours": "Học tập chuyên sâu trực tuyến (giờ học)",
    "onlineSelfLearnHours": "Tự học trực tuyến (giờ học)",
    "outCompanyLearnHours": "Du học (giờ học)",
    "allHours": "tổng thời gian",
    "onlineSelfLearn": "Học trực tuyến tự chủ",
    "onlineCentralizedLearning": "Học tập chuyên sâu trực tuyến",
    "outCompanyLearn": "Nghiên cứu đơn vị nước ngoài",
    "faceTrain": "Đào tạo trực diện",
    "myNotice": "Tin nhắn của tôi",
    "noticeSearchTips": "Tìm kiếm tin tức bạn quan tâm",
    "systemNotice": "Hệ thống nhắc nhở",
    "message": "Thư riêng"
  },
  "questionnaire": {
    "notParticipat": "Không liên quan",
    "description": "Mô tả bảng câu hỏi",
    "save": "tiết kiệm",
    "export": "Xuất khẩu",
    "printing": "in",
    "handed": "thực hiện một nhiệm vụ",
    "topics": "đề tài",
    "examList": "Danh sách các câu hỏi kiểm tra",
    "tableQuestions": "Bảng câu hỏi",
    "newLine": "Thêm dòng",
    "deleteLine": "Xóa hàng",
    "sort": "Số sê-ri",
    "content": "Nội dung",
    "shortQuestion": "Câu trả lời ngắn",
    "inputContent": "Vui lòng nhập nội dung câu trả lời",
    "multiple": "Nhiều lựa chọn",
    "single": "Nhiều lựa chọn",
    "saveSuccess": "Lưu thành công",
    "submitSuccess": "gửi thành công",
    "submitTips": "Bạn đã gửi bảng câu hỏi thành công, cảm ơn bạn đã tham gia",
    "closePage": "Đóng trang này"
  },
  "play": {
    "endStudy": "Kết thúc nghiên cứu",
    "tips": "Lời khuyên",
    "playTips": "Nhắc nhở: Để đảm bảo thời gian học của bạn được hệ thống ghi lại bình thường, vui lòng nhấp vào nút \"Kết thúc học\" ở góc trên bên phải để thoát khỏi nghiên cứu. Nếu bạn trực tiếp đóng trình duyệt, thời gian học của bạn có thể không được ghi lại bình thường.",
    "notShowAgain": "Đừng nhắc lại thông báo này",
    "gotIt": "Tôi hiểu rồi",
    "chapter": "chương",
    "chapterText1": "Đầu tiên",
    "chapterText2": "chương",
    "note": "ghi chú",
    "noteBlockTitle": "ghi chú",
    "evaluate": "Đánh giá",
    "evaluateStar": "ngôi sao",
    "saveEvaluate": "Gửi đi",
    "notePlaceholder": "Vui lòng nhập ghi chú",
    "closeTips": "Hệ thống có thể không lưu các thay đổi của bạn",
    "closeButton": "đi chỗ khác",
    "autoStop": "Tự động dừng chơi",
    "autoStopTips": "Do bạn đã lâu không hoạt động nên hệ thống tự động dừng phát video",
    "confirmOut": "Bạn có chắc chắn bỏ chơi không?",
    "closeOrNot": "Có đóng cửa sổ hiện tại không",
    "noCoursePlay": "Không có phần mềm có thể chơi được trong khóa học hiện tại",
    "attention": "Xin lưu ý!"
  }
};